import axios from '@api/axiosInstance.js'

export const fetchCategories = async ({ assetId }) => {
  const res = await axios.post('/coin-insight/info/exchanges', { assetId })
  return res.data
}
export const fetchCandle = async ({ assetId, marketType, interval }) => {
  const res = await axios.post('/candle/list', { assetId, marketType, interval })
  return res.data
}

export const fetchCoinStockInfo = async ({ assetId, marketType }) => {
  const res = await axios.post('/coin-insight/info/market-price', { assetId, marketType })
  return res.data
}

export const fetchDailyPrice = async ({ assetId, marketType, count }) => {
  const body = { assetId, marketType }

  if (count !== undefined) {
    body.count = count
  }

  const res = await axios.post('/coin-insight/indicator/daily-price', body)
  return res.data
}
